/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   City Groups for other components
 */

import * as DefaultCities from '../../shared/constants/default_cities'
import { buildStaticImageUrl } from '../../shared/utils/image'

export const POPULAR_USA_CITIES = [
  {
    ...DefaultCities.NEW_YORK,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/ny.jpg' }),
  },
  {
    ...DefaultCities.SAN_FRANCISCO,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/sf.jpg' }),
  },
  {
    ...DefaultCities.CHICAGO,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/chi.jpg' }),
  },
  {
    ...DefaultCities.ATLANTA,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/atlanta.jpg' }),
  },
  {
    ...DefaultCities.BOSTON,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/boston.jpg' }),
  },
  {
    ...DefaultCities.LOS_ANGELES,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/la.jpg' }),
  },
  {
    ...DefaultCities.DALLAS,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/dallas.jpg' }),
  },
  {
    ...DefaultCities.DENVER,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/denver.jpg' }),
  },
  {
    ...DefaultCities.HOUSTON,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/houston.jpg' }),
  },
]

export const POPULAR_CAN_CITIES = [
  {
    ...DefaultCities.MONTREAL,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/montreal.jpg' }),
  },
  {
    ...DefaultCities.TORONTO,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/toronto.jpg' }),
  },
  {
    ...DefaultCities.VANCOUVER,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/vancouver.jpg' }),
  },
  {
    ...DefaultCities.CALGARY,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/calgary.jpg' }),
  },
  {
    ...DefaultCities.OTTAWA,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/ottawa.jpg' }),
  },
  {
    ...DefaultCities.EDMONTON,
    backgroundImage: buildStaticImageUrl({ url: 'img/homepage/edmonton.jpg' }),
  },
]

export const MORE_POPULAR_CITIES = [
  DefaultCities.ARLINGTON,
  DefaultCities.AUSTIN,
  DefaultCities.BALTIMORE,
  DefaultCities.CHARLOTTE,
  DefaultCities.COLORADO_SPRINGS,
  DefaultCities.DETROIT,
  DefaultCities.FORT_WORTH,
  DefaultCities.INDIANAPOLIS,
  DefaultCities.KANSAS_CITY,
  DefaultCities.LAS_VEGAS,
  DefaultCities.MEMPHIS,
  DefaultCities.MIAMI,
  DefaultCities.MINNEAPOLIS,
  DefaultCities.NASHVILLE,
  DefaultCities.OAKLAND,
  DefaultCities.ORLANDO,
  DefaultCities.PHILADELPHIA,
  DefaultCities.PHOENIX,
  DefaultCities.PORTLAND,
  DefaultCities.QUEBEC_CITY,
  DefaultCities.SACRAMENTO,
  DefaultCities.SAN_ANTONIO,
  DefaultCities.SAN_DIEGO,
  DefaultCities.SAN_JOSE,
  DefaultCities.SEATTLE,
  DefaultCities.TAMPA,
  DefaultCities.WASHINGTON_DC,
  DefaultCities.WINNIPEG,
]

export const TOP_TWENTY_USA_CITIES = [
  DefaultCities.ATLANTA,
  DefaultCities.AUSTIN,
  DefaultCities.BOSTON,
  DefaultCities.CHARLOTTE,
  DefaultCities.CHICAGO,
  DefaultCities.DALLAS,
  DefaultCities.DENVER,
  DefaultCities.DETROIT,
  DefaultCities.HOUSTON,
  DefaultCities.LOS_ANGELES,
  DefaultCities.MIAMI,
  DefaultCities.MINNEAPOLIS,
  DefaultCities.NEW_YORK,
  DefaultCities.PHILADELPHIA,
  DefaultCities.PHOENIX,
  DefaultCities.SAN_DIEGO,
  DefaultCities.SAN_FRANCISCO,
  DefaultCities.SAN_JOSE,
  DefaultCities.SEATTLE,
  DefaultCities.WASHINGTON_DC,
]

export const TOP_TWENTY_FIVE_USA_CITIES = [
  DefaultCities.ATLANTA,
  DefaultCities.AUSTIN,
  DefaultCities.BALTIMORE,
  DefaultCities.BOSTON,
  DefaultCities.CHARLOTTE,
  DefaultCities.CHICAGO,
  DefaultCities.DALLAS,
  DefaultCities.DENVER,
  DefaultCities.DETROIT,
  DefaultCities.HOUSTON,
  DefaultCities.LAS_VEGAS,
  DefaultCities.LOS_ANGELES,
  DefaultCities.MIAMI,
  DefaultCities.MINNEAPOLIS,
  DefaultCities.NEW_YORK,
  DefaultCities.PHILADELPHIA,
  DefaultCities.PHOENIX,
  DefaultCities.PITTSBURGH,
  DefaultCities.PORTLAND,
  DefaultCities.SAN_ANTONIO,
  DefaultCities.SAN_DIEGO,
  DefaultCities.SAN_FRANCISCO,
  DefaultCities.SEATTLE,
  DefaultCities.TAMPA,
  DefaultCities.WASHINGTON_DC,
]

export const TOP_FIVE_CAN_CITIES = [
  DefaultCities.CALGARY,
  DefaultCities.MONTREAL,
  DefaultCities.OTTAWA,
  DefaultCities.TORONTO,
  DefaultCities.VANCOUVER,
]
